export default __webpack_public_path__ + "static/media/ava.c16df040.svg";